import React, { useEffect, useState } from 'react';
import './PerformancePage.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import ReactApexChart from 'react-apexcharts';
import { Space, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { API_URL } from '../../Config';

const PerformancePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const username = user.user;
  const [tasks, setTasks] = useState([]);
  const [pendingTaskCount, setPendingTaskCount] = useState();
  const [inCompleteTask, setInCompleteTask] = useState();
  const [inProcessTaskCount, setInProcessTaskCount] = useState();
  const [completedTaskCount, setCompletedTaskCount] = useState();

  // =================== tasks data ========================================
  useEffect(() => {
    let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/tasks/all';
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) =>{
        const inComplete = data.filter(task => task.status === 'Pending');
        setTasks(data)
        setInCompleteTask(inComplete)
      })
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  useEffect(() => {
    if (tasks.length > 0) {
      let pendingcount = 0;
      let inProcessCount = 0;
      let completedCount = 0;
      tasks.forEach(i => {
        if (i.status === 'Pending') {
          pendingcount++;
        } else if (i.status === "In-Process") {
          inProcessCount++;
        } else if (i.status === "Completed") {
          completedCount++;
        }
      })
      setPendingTaskCount(pendingcount);
      setInProcessTaskCount(inProcessCount);
      setCompletedTaskCount(completedCount);
    } else {
      setPendingTaskCount(0);
      setInProcessTaskCount(0);
      setCompletedTaskCount(0);
    }
  }, [tasks])
 //========================================================================= 

 // =================== Employee data =========================================
 const [users, setUsers] = useState([]);
 const [totalUser, setTotalUser] = useState();
 useEffect(() => {
  let endpoint = API_URL + `/users/?filter=${username.username}`;

  if (username.role === 'Admin' || username.role === 'HR') {
    endpoint = API_URL + '/users';
  }
  fetch(endpoint)
    .then((response) => response.json())
    .then((data) => setUsers(data))
    .catch((error) => console.error(error));
}, [username.username, username.role]);

useEffect(() => {
  if (users.length > 0) {
    let totalUser = 0;
    totalUser = users.length;
    setTotalUser(totalUser)
  } else {
    setTotalUser(0);
  }
}, [users.length])

 //=========================================================================

 const getUserDetails = (username) => {
  const filteredUser = users.filter(user => user.username === username);
  navigate('/IndividualPerformance', { state: { userDetails: filteredUser[0] } });
};

  const [chartData, setChartData] = useState({
    series: [0, 0, 0],
    options: {
      chart: {
        type: 'donut',
      },
      colors: ['#761F1F', '#A56D2B', '#215115'],
      labels: ['Pending', 'In-Process', 'Complete'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      }],
    },
  });

  useEffect(() => {
    if (pendingTaskCount !== undefined && inProcessTaskCount !== undefined && completedTaskCount !== undefined) {
      setChartData({
        series: [pendingTaskCount, inProcessTaskCount, completedTaskCount],
        options: chartData.options,
      });
    }
  }, [pendingTaskCount, inProcessTaskCount, completedTaskCount, chartData.options]);


  const state = {
    series: [
      {
        name: 'Pending',
        data: [pendingTaskCount || 0],
        color: '#761F1F',
      },
      {
        name: 'In-Process',
        data: [inProcessTaskCount || 0],
        color: '#A56D2B',
      },
      {
        name: 'Complete',
        data: [completedTaskCount || 0],
        color: '#215115',
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          borderRadius: 2,
          horizontal: false,

        }
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [''],

      },
    },
  };


  const ColumnsOf_PerformacePage = [
    {
      title: 'Index',
      dataIndex: 'Index',
      key: 'Index',
      width: '15%',
    },
    {
      title: 'Name',
      dataIndex: 'Name6',
      key: 'Name6',
      width: '25%',
    },
    {
      title: 'Role',
      key: 'Role',
      dataIndex: 'Role',
      render: (_, { Role }) => (
        <>
          {Role.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'Admin') {
              color = '#173452';
            }
            else if (tag === 'HR') {
              color = '#173452';
            }
            else if (tag === 'Manager') {
              color = '#b5cce8';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Select',
      dataIndex: 'Select',
      key: 'Select',
      render: (_, record) => (
        <Space size="middle">
          <input type='checkbox'></input>
        </Space>
      ),
    },
    {
      title: 'Download',
      dataIndex: 'Select',
      key: 'Select',
      render: (_, record) => (
        <Space size="middle">
          <img src='../assets/download.png' alt='download' height={'16vh'} ></img>
        </Space>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: '10%',
      render: (_, record) => (
        <Space size="middle">
          <button className='view_more_btn_perfomance' onClick={() => getUserDetails(record.Name6)}>
           View more
          </button>
        </Space>
      ),
    },
  ];
  // const dataOf_PerformacePage = [
  //   {
  //     key: '1',
  //     Index: 1,
  //     Name6: '$PerformancePage_Table',
  //     Role: ['Super Admin'],
  //     Action: 'View More',
  //   },
  //   {
  //     key: '2',
  //     Index: 2,
  //     Name6: '$PerformancePage_Table',
  //     Role: ['Employee'],
  //   },
  //   {
  //     key: '3',
  //     Index: 3,
  //     Name6: '$PerformancePage_Table',
  //     Role: ['Hr Admin'],
  //   },
  // ];

  const dataa = users.length > 0 ? users.map((item, index) => ({
    key: index.toString(),
    Index: index + 1,
    Name6: item.username || '',
    Role: [item.role || ''],
  })) : [];

  const [isIsFormOpenFor_TotalEmployee, setIsFormOpenFor_TotalEmployee] = useState(false);
  const [isIsFormOpenFor_EmployeeOfMonth, setIsFormOpenFor_EmployeeOfMonth] = useState(false);
  const [isIsFormOpenFor_EmployeeMostTasksCompleted, setIsFormOpenFor_EmployeeMostTasksCompleted] = useState(false);
  const [isIsFormOpenFor_TotalPendingTasks, setIsFormOpenFor_TotalPendingTasks] = useState(false);

  const openForm1 = () => {
    setIsFormOpenFor_TotalEmployee(true);
  };

  const closeForm1 = () => {
    setIsFormOpenFor_TotalEmployee(false);
  };

  const openForm2 = () => {
    setIsFormOpenFor_EmployeeOfMonth(true);
  };

  const closeForm2 = () => {
    setIsFormOpenFor_EmployeeOfMonth(false);
  };

  const openForm3 = () => {
    setIsFormOpenFor_EmployeeMostTasksCompleted(true);
  };

  const closeForm3 = () => {
    setIsFormOpenFor_EmployeeMostTasksCompleted(false);
  };

  const openForm4 = () => {
    setIsFormOpenFor_TotalPendingTasks(true);
  };

  const closeForm4 = () => {
    setIsFormOpenFor_TotalPendingTasks(false);
  };

  const ColumnsOf_TotalEmployee = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno',
      key: 'Srno',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name2',
      key: 'Name2',
    },
  ];

  const dataOf_TotalEmployee = (users && users.length > 0) ? users.map((item, index) => ({
    key: index.toString(),
    Srno: index + 1,
    Name2: `${item.username} (${item.role}) `  || '',
  })) : [];


  const ColumnsOf_EmployeeOfMonth = [
    {
      title: 'Rank',
      dataIndex: 'Srno2',
      key: 'Srno2',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name3',
      key: 'Name3',
    },
  ];
  const dataOf_EmployeeOfMonth = [
    {
      key: '1',
      Srno2: 1,
      Name3: '$EmployeeOfMonth',
    },
    {
      key: '2',
      Srno2: 2,
      Name3: '$EmployeeOfMonth',
    },
    {
      key: '3',
      Srno2: 3,
      Name3: '$EmployeeOfMonth',
    },
  ];


  const ColumnsOf_EmployeeMostTasksCompleted = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno3',
      key: 'Srno3',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name4',
      key: 'Name4',
    },
  ];
  const dataOf_EmployeeMostTasksCompleted = [
    {
      key: '1',
      Srno3: 1,
      Name4: '$EmployeeMostTasksCompleted',
    },
  ];


  const ColumnsOf_TotalPendingTask = [
    {
      title: 'Sr no.',
      dataIndex: 'Srno4',
      key: 'Srno4',
      width: '20%',
    },
    {
      title: 'Name',
      dataIndex: 'Name5',
      key: 'Name5',
    },
    {
      title: 'Task Details',
      dataIndex: 'taskDetails',
      key: 'taskDetails',
    },
  ];

  const dataOf_TotalPendingTask = (inCompleteTask && inCompleteTask.length > 0) ? inCompleteTask.map((item, index) => ({
    key: index.toString(),
    Srno4: index + 1,
    Name5: item.assignee || '',
    taskDetails: item.taskDetails || '',
  })) : [];



  return (
    <div>
      <SideMenuBar></SideMenuBar>

      <div class="content">
        <NewHeader></NewHeader>

        <div className='row2'>
          <h3 className='performance_PerformancePage'>Performance</h3>
        </div>

        <div class="row4_PerformancePage">
          <div class="column1_row4_PerformancePage" onClick={openForm1}>
            <p>Total Employees</p>
            <h3>{totalUser || 0}</h3>
          </div>
          {isIsFormOpenFor_TotalEmployee && (
            <>
              <div className="overlay_PerformancePage" onClick={closeForm1}></div>
              <div className="popup-form_PerformancePage">
                <span className="close_PerformancePage" onClick={closeForm1}>&times;</span>
                <p><b>Total Employees</b></p><br />
                {/* Your form content goes here */}
                <form>
                  {/* Form fields go here */}
                  <div>
                    <Table
                      columns={ColumnsOf_TotalEmployee}
                      dataSource={dataOf_TotalEmployee}
                      scroll={{ y: 400 }}
                      pagination={false}
                    />
                  </div>
                </form>
              </div>
            </>
          )}

          <div class="column2_row4_PerformancePage" onClick={openForm2}>
            <p>Employee of the Month</p>
            <h3>$123</h3>
          </div>
          {isIsFormOpenFor_EmployeeOfMonth && (
            <>
              <div className="overlay_PerformancePage" onClick={closeForm2}></div>
              <div className="popup-form_PerformancePage">
                <span className="close_PerformancePage" onClick={closeForm2}>&times;</span>
                <p><b>Employee of the Month</b></p><br />
                {/* Your form content goes here */}
                <form>
                  {/* Form fields go here */}
                  <div>
                    <Table
                      columns={ColumnsOf_EmployeeOfMonth}
                      dataSource={dataOf_EmployeeOfMonth}
                      scroll={{ y: 400 }}
                      pagination={false}
                    />
                  </div>
                </form>
              </div>
            </>
          )}

          <div class="column3_row4_PerformancePage" onClick={openForm3}>
            <p>Employee Most Tasks Completed</p>
            <h3>$123</h3>
          </div>
          {isIsFormOpenFor_EmployeeMostTasksCompleted && (
            <>
              <div className="overlay_PerformancePage" onClick={closeForm3}></div>
              <div className="popup-form_PerformancePage">
                <span className="close_PerformancePage" onClick={closeForm3}>&times;</span>
                <p><b>Employee Most Tasks Completed</b></p><br />
                {/* Your form content goes here */}
                <form>
                  {/* Form fields go here */}
                  <div>
                    <Table
                      columns={ColumnsOf_EmployeeMostTasksCompleted}
                      dataSource={dataOf_EmployeeMostTasksCompleted}
                      scroll={{ y: 400 }}
                      pagination={false}
                    />
                  </div>
                </form>
              </div>
            </>
          )}

          <div class="column4_row4_PerformancePage" onClick={openForm4}>
            <p>Total Pending Tasks</p>
            <h3>{pendingTaskCount || 0}</h3>
          </div>
          {isIsFormOpenFor_TotalPendingTasks && (
            <>
              <div className="overlay_PerformancePage" onClick={closeForm4}></div>
              <div className="popup-form_PerformancePage">
                <span className="close_PerformancePage" onClick={closeForm4}>&times;</span>
                <p><b>Total Pending Tasks</b></p><br />
                {/* Your form content goes here */}
                <form>
                  {/* Form fields go here */}
                  <div>
                    <Table
                      columns={ColumnsOf_TotalPendingTask}
                      dataSource={dataOf_TotalPendingTask}
                      scroll={{ y: 400 }}
                      pagination={false}
                    />
                  </div>
                </form>
              </div>
            </>
          )}
        </div>

        {/*
        <div class="row5_PerformancePage">
            <h4 className='daily_row5_PerformancePage'><a href='/'>Daily</a></h4>
            <h4 className='weekly_row5_PerformancePage'><a href='/'>Weekly</a></h4>
            <h4 className='monthly_row5_PerformancePage'><a href='/'>Monthly</a></h4>
        </div>
        */}

        <div className='row5_PerformancePage'>
          <label className='daily_label'>
            <input className='input_row5_PerformancePage' type="radio" name="radioBtn" /><span class="option_row5_PerformancePage">Daily</span>&nbsp;&nbsp;
          </label>

          <label className='weekly_label'>
            <input className='input_row5_PerformancePage' type="radio" name="radioBtn" /><span class="option_row5_PerformancePage" >Weekly</span>&nbsp;&nbsp;
          </label>

          <label>
            <input className='input_row5_PerformancePage' type="radio" name="radioBtn" /><span class="option_row5_PerformancePage" >Monthly</span>&nbsp;&nbsp;
          </label>

          <label>
            <input className='input_row5_PerformancePage' type="radio" name="radioBtn" /><span class="option_row5_PerformancePage" >Overall</span>
          </label>
        </div>

        <div class="row6_PerformancePage">
          <div class="column1_row6_PerformancePage">
            <ReactApexChart options={chartData.options} series={chartData.series} dataLabels={chartData.name} type="donut" height={"340vh"} />
            {/*<img className='map' src='../assets/map.png' alt='map' height={250} width={'100%'}></img>*/}
          </div>

          <div class="column2_row6_PerformancePage">
            <ReactApexChart options={state.options} series={state.series} type="bar" height={"240%"} />
            {/*<img className='chart' src='../assets/chart.png' alt='chart' height={250} width={'100%'}></img>*/}
          </div>
        </div>

        <div className='row7_PerformancePage'>
          <h4>Individual Performances</h4>
        </div>

        <div class="row8_PerformancePage">
          <Table
            columns={ColumnsOf_PerformacePage}
            dataSource={dataa}
            scroll={{ y: 400 }}
            pagination={false}
          />

        </div><br /><br />

      </div>
    </div>
  )
}

export default PerformancePage;